import React, { useEffect } from "react";
import NavbarEnlaces from "../../../layout/NavbarEnlaces";
import Accordion from "../../../layout/Accordion/Accordion";
import AccordionItem from "../../../layout/Accordion/AccordionItem";
import {
  dataAcuerdosOIC,
  dataAcuerdosOICAG,
} from "../../../data/dataOIC";

export const AcuerdosOIC = () => {
  useEffect(() => {
    document.title = "Acuerdos OIC";
  }, []);

  const renderAcuerdos = (data, accordionId) => (
    <Accordion idAccordion={accordionId}>
      {data.map((item) => (
        <AccordionItem
          key={item.id}
          flushID={`${accordionId}-${item.id}`}
          titleItem={item.titleItem}
          idAccordion={accordionId}
          contentItem={
            <div className="w-75 mx-auto mb-3">
              {/* DOCUMENTO PRINCIPAL */}
              <ul className="list-group mb-3">
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  <span>
                    <i className="fa fa-file-pdf text-danger me-2"></i>
                    {item.titleItem}
                  </span>

                  <a
                    href={item.linkItem}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-danger btn-sm"
                  >
                    <i className="fa fa-eye me-1"></i>
                    Abrir
                  </a>
                </li>
              </ul>

              {/* SUBDOCUMENTOS */}
              {item.subDocuments?.length > 0 && (
                <ul className="list-group">
                  {item.subDocuments.map((doc) => (
                    <li
                      key={doc.id}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <span>
                        {doc.typeDocument === "pdf" && (
                          <i className="fa fa-file-pdf text-danger me-2"></i>
                        )}

                        {doc.typeDocument === "excel" && (
                          <i className="fa fa-file-excel text-success me-2"></i>
                        )}

                        {doc.title}
                      </span>

                      <a
                        href={doc.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline-secondary btn-sm"
                      >
                        <i className="fa fa-eye me-1"></i>
                        Abrir
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          }
        />
      ))}
    </Accordion>
  );

  return (
    <div className="margin-bottom-2">
      <NavbarEnlaces title="Órgano Interno de Control - Acuerdos" />

      {/* Primera sección */}
      <div className="container mb-5">
        <h3 className="text-center mb-4">
          Acuerdos OIC
        </h3>

        {renderAcuerdos(dataAcuerdosOIC, "acuerdosOIC")}
      </div>

      {/* Segunda sección */}
      <div className="container">
        <h3 className="text-center mb-4">
          Acuerdos emitidos por la Autoridad Garante
        </h3>

        {renderAcuerdos(dataAcuerdosOICAG, "acuerdosOICAG")}
      </div>
    </div>
  );
};

export default AcuerdosOIC;